import { Component, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormControlName, Validators } from '@angular/forms';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';
import { Router } from '@angular/router';
@Component({
  selector: 'app-tool-shifting-form',
  templateUrl: './tool-shifting-form.component.html',
  styleUrls: ['./tool-shifting-form.component.scss']
})

export class ToolShiftingFormComponent {
  breadcrumb = [
    {
      title: "Tool Shifting Form",
      subTitle: "Dashboard",
    },
  ];
  @ViewChild('oldSupplierDropdown') oldsupplier: any;
  supplierList: any[] = [];
  assetwisedata: any;
  selectedSupplierId: any;
  selectedSuppliername: any
  submitted = false
  previewUrl: string | ArrayBuffer;
  ToolshiftingData: any[] = []
  oldsupplierid: number;
  isshowform: boolean = false;
  filterval: any
  constructor(
    private fb: FormBuilder,
    private _utility: AppUtility,
    private _apiService: ApiServiceService,
    private router:Router
  ) { }
  ngOnInit() {
    this.getAllSupplierDetail();
    console.log(this.router.url);

  }

  toolshiftingForm = this.fb.group({
    supplierid: new FormControl(null),
    SupplierAddress: new FormControl(null, []),
    SupplierNamenew: new FormControl(null),
    SupplierAddressnew: new FormControl(null),
    Jdecode: new FormControl(null),
    remarks: new FormControl(null),
    Item_Desc: new FormControl(null),
    lr_copy: new FormControl(null),
    dc_supplier: new FormControl(null, [Validators.required]),
    rmg_doc: new FormControl(null, [Validators.required])
  })

  getassetdata() {
    this._utility.loader(true)
    console.log(this.oldsupplierid);

    if (!this.oldsupplierid) {
      this._utility.loader(false)
      this._apiService.showMessage('Please select a Supplier Name', 'error');
      return;
    }
    const id = this.oldsupplierid;
    console.log(id);

    if (id) { 
      this._apiService.getdatabysupplierid(id).then((res: any) => {
        this._utility.loader(false)
        if (res['success']) {
          this.assetwisedata = res['returnValue'];
          if (Array.isArray(this.assetwisedata) && this.assetwisedata.length > 0) {
            console.log('Asset data received');
            const data = this.assetwisedata[0];
            console.log(data);
            this.isshowform = true;
          } else {
            this.assetwisedata = [];
            this.isshowform = false;
            this._apiService.showMessage('No data found for this supplier', 'error');
          }
        } else {
          // Failure response
          this._apiService.showMessage('Failed to fetch data', 'error');
        }
      })
        .catch((error) => {
          this._utility.loader(false);
          this._apiService.showMessage('Something went wrong while fetching data', 'error');
          console.error(error);
        });
    }
  }

  getSupplierData(data: any, source: any) {
    if (source == 'old') {
      var part = data.value;
      this.oldsupplierid = data.value;
      return;
    }
    else {
      console.log(data)
      var part = data.value;
      this.selectedSupplierId = data.value;
      console.log(this.selectedSupplierId, "new id");

      this.supplierList.forEach((key: any) => {
        if (key.supplierId == part) {
          this.toolshiftingForm.controls.Jdecode.setValue(key.jdeNo);
          this.toolshiftingForm.controls.SupplierAddressnew.setValue(key.address1);
          this.selectedSupplierId = key.supplierId;
          this.selectedSuppliername = key.supplierName;
        }
      });
    }
  }

    submitForm() {
      if (this.selectedSupplierId===this.oldsupplierid){
        return this._apiService.showMessage('Selected and current supplier can’t be the same.','error')
      }
      this.submitted = true
      console.log(this.toolshiftingForm.value);
      console.log(this.toolshiftingForm.controls.SupplierNamenew, "checked data");
      const id = this.assetwisedata.filter(tool => tool.selected);
      console.log(id, "id");
        console.log( this.toolshiftingForm.valid);
        console.log( this.toolshiftingForm);

      if (this.toolshiftingForm.valid) {
        this._utility.loader(true)
        const formdata = new FormData();
        console.log(typeof this.selectedSupplierId, "end");
        formdata.append('OldSupplierId', JSON.stringify(this.oldsupplierid)),
          formdata.append('NewSupplierId', this.selectedSupplierId),
          formdata.append('RMGOfIdexToNewSupplier', this.toolshiftingForm.controls['rmg_doc'].value),
          formdata.append('DCOfExistingSupplier', this.toolshiftingForm.controls['dc_supplier'].value)
          formdata.append('LRCopyOfTransporter', this.toolshiftingForm.controls['lr_copy'].value)
          formdata.append('ToolLoanDetailIds', id?.map((item: any) => item.toolLoanDetailId) || []),
          formdata.append('Remarks', this.toolshiftingForm.controls['remarks'].value),
          formdata.append('AssetCode', id?.map((item: any) => item.assetCode) || []),
          formdata.append('SupplierName', this.selectedSuppliername),
           formdata.append('jdecode', this.toolshiftingForm.controls['Jdecode'].value)
          this._apiService.toolshifting(formdata)
            .then(response => {
              this._utility.loader(true)
              console.log('API response:', response);
              this._utility.loader(false);
              this._apiService.showMessage(response.message, 'success');
              setTimeout(() => {
              this.router.navigateByUrl("/tool-shifting-listing")
              }, 1000);
            })
      }
      else{
        this._apiService.showMessage('please fill All Details','error')
      }
    }
  uploadDoc(event: Event, fileType: string, index?: number) {
    console.log(fileType, ":data");
    const file = this._utility.onFileChange(event);
    if (!file) {
      console.error('Invalid file selected:', file);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      this.previewUrl = reader.result;
    };
    reader.readAsDataURL(file);


    switch (fileType) {
      case 'lr_copy':
        console.log(fileType);

        this.toolshiftingForm.controls['lr_copy'].setValue(file);
        break;
      case 'dc':
        console.log(fileType);

        this.toolshiftingForm.controls['dc_supplier'].setValue(file);
        break;
      case 'Rmg':
        console.log(fileType);
        this.toolshiftingForm.controls['rmg_doc'].setValue(file)
        break;
    }

  }
  getAllSupplierDetail() {
    this._utility.loader(true);
    this._apiService.getSupplier().then((res: any) => {
      console.log(res);
      this._utility.loader(false);
      if (res.success == true) {
        this.supplierList = res.returnValue;
        console.log(this.supplierList, "change");

      } else {
        this._utility.loader(false)
        this.supplierList = [];
      }
    });
  }
  reset(dt2) {
    dt2.reset();
    this.filterval = ''
  }
  resetOldSupplier() {
    this.oldsupplier.clear(null); 
    this.isshowform = false
  }
}
